"use strict";
exports.__esModule = true;
exports.toUpper = exports.toLower = exports.includes = exports.replace = exports.startsWith = exports.join = exports.split = void 0;
var split = function (char) { return function (string) { return string.split(char); }; };
exports.split = split;
var join = function (char) { return function (strings) { return strings.join(char); }; };
exports.join = join;
var startsWith = function (a) { return function (b) { return b.startsWith(a); }; };
exports.startsWith = startsWith;
var replace = function (r, a) { return function (b) { return b.replace(r, a); }; };
exports.replace = replace;
var includes = function (a) { return function (b) { return b.includes(a); }; };
exports.includes = includes;
var toLower = function (a) { return a.toLowerCase(); };
exports.toLower = toLower;
var toUpper = function (a) { return a.toUpperCase(); };
exports.toUpper = toUpper;
